(function(){
  function onReady(fn){
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function detectScroller(){
    // Muitos temas Shopify usam #MainContent como container scrollável; se não houver, usa window
    return document.querySelector('#MainContent') || null;
  }

  function hasTransform(el){
    const t = getComputedStyle(el).transform;
    return t && t !== 'none';
  }

  function waitImage(img, cb){
    if(!img || img.complete) { cb(); return; }
    img.addEventListener('load', cb, {once:true});
    img.addEventListener('error', cb, {once:true});
  }

  function animateBenefits(benefits, effect){
    benefits.forEach((b,i)=>{
      let from={opacity:0}, to={opacity:1, duration:.6, ease:'power2.out', delay:i*0.08};
      switch(effect){
        case 'fade-up': from.y=20; to.y=0; break;
        case 'fade-right': from.x=-20; to.x=0; break;
        case 'skew-in': from.y=18; from.skewY=6; to.y=0; to.skewY=0; to.duration=.7; break;
        default: from.scale=.92; to.scale=1; to.duration=.55;
      }
      gsap.fromTo(b, from, to);
    });
  }

  function initOne(root){
    if(!root || root.dataset.pfqInited) return;
    root.dataset.pfqInited = '1';

    const productEl = root.querySelector('.pfq-product');
    const heroEl    = root.querySelector('.pfq-hero');
    const frameEl   = root.querySelector('.pfq-benefits-frame');
    const benefits  = root.querySelectorAll('.pfq-benefit');

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const effect = root.dataset.effect || 'zoom-in';
    const startVh = parseFloat(root.dataset.start || '0');
    const endVh   = parseFloat(root.dataset.end   || '35');
    const vhToPx  = v => window.innerHeight * (v/100);

    // Se GSAP/ScrollTrigger não carregaram, mostra conteúdo sem animação
    if(prefersReduced || !(window.gsap && window.ScrollTrigger) || !heroEl){
      benefits.forEach(b=>{ b.style.opacity=1; b.style.transform='translate(-50%,-50%)'; });
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const scroller = detectScroller();
    const pinType =
      (hasTransform(document.documentElement) || hasTransform(document.body)) ? 'transform' : 'fixed';

    // Se houver scroller custom, avisa o ScrollTrigger
    if (scroller) {
      ScrollTrigger.scrollerProxy(scroller, {
        scrollTop(value){ if(arguments.length){ scroller.scrollTop = value; } return scroller.scrollTop; },
        getBoundingClientRect(){ return { top:0, left:0, width:window.innerWidth, height:window.innerHeight }; },
        pinType
      });
      // sincroniza atualizações
      scroller.addEventListener('scroll', ScrollTrigger.update);
    }

    function build(){
      // Linha do movimento + pin
      const tl = gsap.timeline({
        defaults: { ease:'none' },
        scrollTrigger: {
          trigger: heroEl,
          start: 'top top',
          end: '+=200%',
          scrub: true,
          pin: true,
          pinSpacing: true,
          anticipatePin: 1,
          invalidateOnRefresh: true,
          pinType,
          ...(scroller ? { scroller } : {})
        }
      });

      if (productEl){
        tl.fromTo(productEl, { y: vhToPx(startVh) }, { y: vhToPx(endVh) });
        // refresh quando a imagem carregar (tamanhos)
        waitImage(productEl, ()=> ScrollTrigger.refresh());
      }

      ScrollTrigger.create({
        trigger: frameEl || heroEl,
        start: frameEl ? 'top 65%' : 'bottom 65%',
        once: true,
        onEnter: ()=>animateBenefits(benefits, effect),
        ...(scroller ? { scroller } : {})
      });

      // Fade-in simples para data-fade
      const io = new IntersectionObserver((ents)=>{
        ents.forEach(e=>{
          if(e.isIntersecting){
            e.target.style.transition = 'opacity .5s ease, transform .5s ease';
            e.target.style.opacity = '1'; e.target.style.transform = 'none';
            io.unobserve(e.target);
          }
        });
      }, {root: scroller || null, rootMargin:'0px 0px -10% 0px', threshold:.08});

      document.querySelectorAll('[data-fade]').forEach(el=>{
        el.style.opacity='0'; el.style.transform='translateY(12px)'; io.observe(el);
      });
    }

    build();
    window.addEventListener('resize', ()=> ScrollTrigger.refresh());
  }

  function bootAll(){
    document.querySelectorAll('[data-pfq-essencial]').forEach(initOne);
  }

  onReady(bootAll);

  // Suporte ao editor Shopify
  document.addEventListener('shopify:section:load', e=>{
    const root = e.target && e.target.querySelector('[data-pfq-essencial]');
    if(root){ delete root.dataset.pfqInited; initOne(root); }
  });
  document.addEventListener('shopify:section:select', e=>{
    const root = e.target && e.target.querySelector('[data-pfq-essencial]');
    if(root){ delete root.dataset.pfqInited; initOne(root); }
  });
})();